import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env';

/**
 * Prefixes all requests not starting with `http[s]` with `environment.serverUrl`.
 */
@Injectable({
  providedIn: 'root',
})
export class ApiPrefixInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (
      !/^(http|https):/i.test(request.url) &&
      !/^(\/assets|assets)/i.test(request.url) &&
      !(environment.baseHref.length > 1 && request.url.startsWith(environment.baseHref))
    ) {
      const apiUrl = request.url.includes('UploadTempFile') ? environment.fileUrl : environment.apiUrl;
      const srvUrl: string = apiUrl.endsWith('/') ? apiUrl : apiUrl + '/';
      const reqUrl: string = request.url.startsWith('/') ? request.url.substr(1) : request.url;

      request = request.clone({ url: srvUrl + reqUrl });
    } else if (environment.baseHref.length > 1 && /^(\/assets|assets)/i.test(request.url)) {
      request = request.clone({ url: environment.baseHref + request.url });
    }
    return next.handle(request);
  }
}
